import useSWR from 'swr';
import { TToolHistoryResponse } from 'types/toolHistory.types';
import { getToolHistory } from 'services/toolsModule';
import { ToolHistoryStepper } from './components/ToolHistoryStepper/ToolHistoryStepper';
import { ToolHistoryTabSkeleton } from './components/ToolHistoryTabSkeleton/ToolHistoryTabSkeleton';
import { formatToolHistory } from './toolHistoryTab.utils';

import './ToolHistoryTab.scss';

/**
 * Tab que muestra el historial de movimientos de una herramienta
 * @param productId - ID del producto
 */
export const ToolHistoryTab = ({ productId }: IToolHistoryTabProps) => {
  const { data: toolHistory, isLoading: isLoadingData } = useSWR<TToolHistoryResponse>(
    productId ? `tool-history-${productId}` : null,
    () => getToolHistory(productId?.toString() || '')
  );

  if (isLoadingData) {
    return (
      <div className="toolHistoryTab">
        <ToolHistoryTabSkeleton />
      </div>
    );
  }

  if (!toolHistory?.length) {
    return (
      <div className="toolHistoryTab">
        <div className="emptyState">No hay historial disponible para esta herramienta</div>
      </div>
    );
  }

  return (
    <div className="toolHistoryTab">
      <div className="historySections">
        <ToolHistoryStepper steps={formatToolHistory(toolHistory)} />
      </div>
    </div>
  );
};

interface IToolHistoryTabProps {
  productId?: number;
}
